import React from 'react';
import styles from '../css/styles.module.css';
import Select from 'react-select';

export default function SearchBar(props){
    const searchStyle = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? "3px solid #C5C5C5 !important" : "3px solid lightskyblue !important",
            boxShadow: "none",
            borderRadius: "8px"
        }),
        option: (provided, state) => ({
            ...provided,
            "&:hover": {
                backgroundColor: "#C5C5C5"
            },
            backgroundColor: state.isSelected && "lightskyblue",
            color: state.isSelected && "black"
        })
    }

    return(
        <div className={styles.searchBarContainer}>
            <Select 
                styles={searchStyle}
                className={styles.searchBar}
                placeholder={props.placeholder}
                noOptionsMessage={() => props.errorMessage}
                options={props.options}
                onChange={(selected) => props.handleSelectChange(selected)}
                isClearable={props.isClearable}
                isSearchable
                isMulti={props.isMulti}
            />
        </div>
    );
}